export const appDoneIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="8" fill="#BDBDBD"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.1818 14.8284L7.79545 12.3209L7 13.1567L10.1818 16.5L17 9.33582L16.2045 8.5L10.1818 14.8284Z" fill="white" stroke="white" stroke-width="0.5"/></svg>`,
    name: 'done'
};